<template>
    <div class="ibox">
        <div class="ibox-title">
            <h5>Edição do Perito</h5>
        </div>

        <div class="ibox-content">
            <form>
                <div>
                    <div class="form-group" :class="{ 'has-error': form.errors.has('partnership_id') }">
                        <label for="partnership_id">Parceiro:</label>
                        <select name="partnership_id"
                                id="partnership_id"
                                class="form-control"
                                @change="onChangePartnership"
                                v-model="form.partnership_id"
                        >
                            <option value="">Sem Parceiro</option>
                            <option v-for="partnership in partnerships"
                                    :key="partnership.id"
                                    :value="partnership.id"
                                    required
                            >
                                {{ partnership.name }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group" :class="{ 'has-error': form.errors.has('package_id') }">
                        <label for="package_id">Plano Cortesia do Gestão:</label>
                        <select name="package_id"
                                id="package_id"
                                class="form-control"
                                v-model="form.package_id"
                        >
                            <option value="">Sem Plano Cortesia</option>
                            <option v-for="credit_package in credit_packages"
                                    :key="credit_package.id"
                                    :value="credit_package.id"
                                    required
                            >
                                {{ credit_package.payment_plan_name }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group" :class="{ 'has-error': form.errors.has('package_expires_at') }">
                        <label for="package_expires_at" class="control-label">Data limite do plano Cortesia:</label>
                        <input type="date"
                                name="package_expires_at"
                                class="form-control"
                                v-model="form.package_expires_at"
                                id="package_expires_at"
                                :min="dateNow"
                                required
                        >
                    </div>  

                    <div class="form-group" :class="{ 'has-error': form.errors.has('package_id') }">
                        <label for="package_id">Plano Recorrente:</label>
                        <select name="package_id"
                                id="package_id"
                                class="form-control"
                                v-model="form.current_package_id"
                        >
                            <option value="">Sem Plano Recorrente</option>
                            <option v-for="credit_package in credit_packages_recurrent"
                                    :key="credit_package.id"
                                    :value="credit_package.id"
                                    required
                            >
                                {{ credit_package.payment_plan_name }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group"> 
                        <input type="checkbox" class="form-check-input" name="give_credits" id="give_credits" v-model="form.current_package_recurrent_credits" value="0">
                        <label class="control-label" for="give_credits">Libera créditos do Plano agora?</label>
                    </div>

                </div>
                
                <div class="form-group">
                    <button class="btn btn-md btn-primary"
                            type="button"
                            :disabled="disabelBtnUpdate"
                            @click.prevent="onUpdate"
                    >
                    Atualizar
                    </button>

                    <a class="btn btn-md btn-default" :href="url_voltar">Voltar</a>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Form from 'form-backend-validation';

export default 
{
    props: {
        user: {
            type: Object,
            required: true,
        },
        user_expert: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            partnerships: [],
            credit_packages:[],
            credit_packages_recurrent:[],
            url_voltar:'',
            dateNow:null,

            form: new Form({
                partnership_id:'',
                package_id:'',
                package_expires_at:'',
                current_package_id:'', 
                current_package_recurrent_credits:''
            }),

            disabelBtnUpdate : false
        };
    },
    mounted() 
    {
        this.form.partnership_id = this.user_expert.partnership_id;
        this.form.package_id = this.user_expert.package_id; 
        this.form.current_package_id = this.user.payment_recurrent_id ? this.user.payment_recurrent_id.package_id : '';
         
        if ( this.user_expert.package_expires_at )
        {
            this.form.package_expires_at = moment(this.user_expert.package_expires_at).format('Y-MM-DD');
        }

        this.url_voltar = '/admin/users/'+this.user.id;

        var date_time = new Date();
        date_time.setTime(date_time.getTime());
        this.dateNow = date_time.toISOString().slice(0,10);

        this.loadPartnership();
        this.loadCreditPackages();
        this.loadCreditPackagesRecurrent();
    },  
    methods: 
    {   
        loadCreditPackagesRecurrent(){

            axios.get('/credit-packages-recurrent/visibles')
                .then(({data}) => {
                    
                    this.credit_packages_recurrent = data; 

                }).catch(() => {
                    
                    toastr.error('Erro ao carregar planos recorrentes!');

                });  

        },

        loadPartnership() {
            axios.get('/admin/configuracoes/partnership/list')
                .then(({data}) => {
                    this.partnerships = data;
                }).catch(() => {
                    toastr.error('Erro ao carregar parceiros!');
                });
        },

        loadCreditPackages() {
            axios.get(`/credit-packages-recurrent/partnership/${this.form.partnership_id}/visibles`)
                .then(({data}) => {
                    this.credit_packages = data;
                    this.form.package_id = this.user_expert.package_id;
                }).catch(() => {
                    toastr.error('Erro ao carregar parceiros!');
                });
        },

        onChangePartnership() {
            if ( this.form.partnership_id != '')
            {
                this.loadCreditPackages();
            }
            else
            {
                this.credit_packages = null;
                this.form.package_id = '';
            }
        },

        onUpdate() {
          this.disabelBtnUpdate = true;
          this.form.patch('/admin/users/expert/'+this.user_expert.id)
            .then((data) => {
                toastr.success('Usuário atualizado com sucesso');
                location.href = this.url_voltar;
            }).catch(() => {
                this.disabelBtnUpdate = false;
                toastr.error('Erro ao atualizar o usuário');
            });
        }
    }
}
</script>
